import api from './api';

const favoriteService = {
  getIds: async () => {
    const response = await api.get('/favorites/ids');
    return response.data;
  },

  list: async (params = {}) => {
    const response = await api.get('/favorites', { params });
    return response.data;
  },

  add: async ({ type, targetId }) => {
    const response = await api.post('/favorites', { type, targetId });
    return response.data;
  },

  remove: async ({ type, targetId }) => {
    const response = await api.delete('/favorites', {
      data: { type, targetId }
    });
    return response.data;
  }
};

export default favoriteService;